<template>
  <v-dialog width="unset" persistent v-model="visibleModel" @keydown.esc="close(false)">
    <v-card>
      <v-form ref="form" lazy-validation>
        <v-card-title>
          选择报价日期
        </v-card-title>
        <v-card-text>
          <v-date-picker first-day-of-week="1" locale="zh-cn" v-model="quoteDate" :rules="rules.required"/>
          <v-file-input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" v-model="file" :rules="rules.required"/>
          <v-row class="text-center mt-3">
            <v-col>
              <v-btn color="primary" x-large :loading="loading" @click="upload('默认')" class="mr-5">默认报表</v-btn>
              <v-btn color="primary" x-large :loading="loading" @click="upload('海卡')">海卡报表</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" :loading="loading" @click="download('默认')">下载默认</v-btn>
          <v-spacer/>
          <v-btn text color="primary" :loading="loading" @click="download('海卡')">下载海卡</v-btn>
          <v-spacer/>
          <v-btn text color="error" :loading="loading" @click="confirmDialog = true">清空数据</v-btn>
          <v-spacer/>
          <v-btn text color="grey" @click="close(false)">关闭</v-btn>
<!--          <v-btn text color="primary" :loading="loading" @click="upload">上传报表</v-btn>-->
        </v-card-actions>
      </v-form>
    </v-card>

    <v-dialog width="unset" persistent v-model="confirmDialog">
      <v-card>
        <v-card-title>确认</v-card-title>
        <v-card-text>确定要删除所有报价记录吗?</v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text color="error" :loading="loading" @click="clear">确认</v-btn>
          <v-btn text color="grey" @click="confirmDialog = false">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "QuotationUploadDialog",
  model: {
    prop: "visible",
    event: "update"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    visibleModel: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update", val);
      }
    }
  },
  data() {
    return {
      confirmDialog: false,
      loading: true,
      file: null,
      quoteDate: dayjs().format("YYYY-MM-DD"),
      rules: {
        required: [
            v => !!v || "此项必填!"
        ]
      }
    }
  },
  methods: {
    getData() {
      this.loading = false
    },
    download(type) {
      this.loading = true
      this.$axios.get("/quotation/download", {params: {quoteDate: this.quoteDate, type: type}, responseType: 'blob'}).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${type}报表-${this.quoteDate}.xlsx`)
        document.body.appendChild(link)
        link.click()
        this.loading = false
      })
    },
    upload(type) {
      if (this.$refs.form.validate()) {
        this.loading = true
        let formData = new FormData()
        formData.append('type', type)
        formData.append('quoteDate', this.quoteDate)
        formData.append('file', this.file)

        this.$axios.post('/quotation/upload', formData).then(
            () => {
              this.loading = false
              this.file = null
              this.close(true)
            }
        ).catch(
            error => {
              console.log("真的进来了. ", error)
              this.loading = false
              this.file = null
            }
        )
      }
    },
    close(flag) {
      this.visibleModel = false

      if (flag) {
        this.$emit('reload')
      }
    },
    clear() {
      this.loading = true
      this.$axios.delete("/channel/clear").then(() => {
        this.confirmDialog = false
        this.loading = false
        this.close(true)
      });
    }
  },
  watch: {
    visibleModel() {
      if (this.visibleModel) {
        this.getData()
      }
    }
  }
}
</script>

<style scoped>

</style>